export default __webpack_public_path__ + "static/media/icon-next-single.f2f84764.svg";